import type { HtmlBareMdNode } from '@ui/MarkdownEditor/types';

export const isHtmlComment = (node: HtmlBareMdNode): boolean => !!node.value.match(/^(\x3C!--)/);
